const breakpoints = [
  '576px',
  '768px',
  '992px',
  '1200px',
];

const space = [
  0,
  8,
  16,
  32,
  64,
  128,
];

const fontSizes = [
  12,
  14,
  16,
  18,
  20,
  24,
  32,
  48,
  64,
  72,
];

const colors = {
  bg: '#FCFCFC',
  greyBorder: '#F2F2F2',
  greyBackground: '#f9f9f9', // TODO: Rename
  darkerGreyBorder: '#E6E7E8', // TODO: Rename
  slate: '#433A53',
  textBluried: '#7D758B',
  disabled: '#B1AABD',
  cvGreen: '#A7F0E0',
  cvGreen2: '#EDFCF9',
};

export default {
  breakpoints,
  space,
  fontSizes,
  colors,
};
